export const parseChildren = (children) => {
  if (!Array.isArray(children)) {
    return [children];
  }
  return children;
};
